export default __webpack_public_path__ + "echoes.mp3";